<template>
  <a-row class="partner-layout">
    <a-col flex="250px" class="partner-layout__left-side">
      <SideBar :items="sidebarItems" />
    </a-col>
    <a-col flex="auto" class="partner-layout__right-side">
      <div class="partner-layout__header">
        <HeaderPartnerAccount />
      </div>
      <div ref="scrollElement" class="partner-layout__content">
        <a-spin
          :spinning="spinning"
          class="custom-spinner"
          style="height: 100vh; top: 20%"
        >
          <slot></slot>
        </a-spin>
      </div>
    </a-col>
  </a-row>
</template>

<script setup>
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import SideBar from '@/components/sidebar/SideBar';
  import HeaderPartnerAccount from '@/components/header/HeaderPartnerAccount';
  import { debounce } from 'lodash-es';

  document.title = 'Цифровой университет. НГУ';

  defineProps({
    spinning: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['scrolled-to-bottom']);
  const scrollThreshold = 30; // Сдвиг в пикселях от края страницы (зазор), когда должен сработать триггер для скролла
  const scrollElement = ref(null);

  onMounted(() => {
    scrollElement.value?.addEventListener('scroll', handleScroll);
  });

  onBeforeUnmount(() => {
    scrollElement.value?.removeEventListener('scroll', handleScroll);
  });

  const handleScroll = debounce(() => {
    const elementHeight = scrollElement.value?.getBoundingClientRect().height;
    const scrollHeight = scrollElement.value?.scrollHeight;
    const scrollBottom = scrollElement.value?.scrollTop + elementHeight;
    if (scrollBottom + scrollThreshold > scrollHeight) {
      emit('scrolled-to-bottom', scrollBottom);
    }
  }, 70);

  // TODO - 3,4,5 - remove 'hidden' and change for actual name, when they become available
  // Path here - is name from router
  const sidebarItems = [
    {
      id: 1,
      text: 'Запрос на проект',
      path: 'request-new',
      type: 'request',
    },
    {
      id: 2,
      text: 'Мои проекты',
      path: 'main',
      type: 'projects',
    },
    {
      id: 3,
      text: 'Витрина',
      type: 'showcases',
      url: '/showcase',
    },
    {
      id: 4,
      text: 'Вакансии',
      path: 'partner-vacancies',
      type: 'vacancies',
      disabled: true,
      hidden: true,
    },
    {
      id: 5,
      text: 'Отчеты',
      path: 'partner-reports',
      type: 'report',
      disabled: true,
      hidden: true,
    },
    {
      id: 6,
      text: 'Документы',
      path: 'partner-documents',
      type: 'docs',
      disabled: true,
      hidden: true,
    },
  ];
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .partner-layout {
    min-height: 100vh;
    flex-wrap: nowrap;

    .partner-layout__right-side {
      overflow: hidden;
      height: 100vh;

      .partner-layout__header {
        border-bottom: 1px solid $color-bg-secondary-grey;
        background-color: $color-bg-primary-white;
        position: sticky;
        padding: 17px 40px 17px 20px;
        top: 0;
        z-index: 1;
      }

      .partner-layout__content {
        overflow-y: auto;
        height: 100%;
        padding: 30px 40px 100px 20px;
      }
    }
  }
</style>
